import type { ExpenseEntry } from '@/lib/mock/expenses';

export const PROJECT_LEDGER_VOUCHER_PRINT_KEY = 'accounting_project_ledger_voucher_print_v1';

export type ProjectLedgerVoucherKind = 'deposit' | 'withdrawal';

export interface ProjectLedgerVoucherPayload {
  voucherNo: string;
  generatedAt: string;
  project: {
    id: number;
    label: string;
  };
  kind: ProjectLedgerVoucherKind;
  kindLabel: string;
  dateFa: string;
  expenseTypeTitle: string;
  beneficiary: string;
  docNo: string;
  credit: number;
  debit: number;
  amount: number;
  amountInWords: string;
  paymentMethod: string;
  description: string;
  sourceLabel: string;
  notes?: string;
}

let memory: ProjectLedgerVoucherPayload | null = null;

export function buildVoucherNo(entry: ExpenseEntry): string {
  const raw = String(entry.id || '').replace(/[^a-zA-Z0-9-]/g, '');
  return raw || `V-${Date.now()}`;
}

export function saveProjectLedgerVoucherPayload(payload: ProjectLedgerVoucherPayload): void {
  memory = payload;
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(PROJECT_LEDGER_VOUCHER_PRINT_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function takeProjectLedgerVoucherPayloadForPage(): ProjectLedgerVoucherPayload | null {
  if (memory) return memory;
  try {
    if (typeof localStorage === 'undefined') return null;
    const raw = localStorage.getItem(PROJECT_LEDGER_VOUCHER_PRINT_KEY);
    if (!raw) return null;
    const payload = JSON.parse(raw) as ProjectLedgerVoucherPayload;
    memory = payload;
    return payload;
  } catch {
    return null;
  }
}

export function releaseProjectLedgerVoucherPrintMemory(): void {
  memory = null;
}
